import React from 'react';

var SvgPersonAddIcon = function SvgPersonAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-1c-.414 0-.75.336-.75.75s.336.75.75.75h1v1c0 .414.336.75.75.75s.75-.336.75-.75v-1h1c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5Zm-2 3.5c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 11c-2.278 0-4.378 1.235-5.484 3.227l-.437.786c-.495.891.15 1.987 1.17 1.987h9.502c1.02 0 1.665-1.096 1.17-1.987l-.437-.786c-1.107-1.992-3.206-3.227-5.484-3.227Zm-4.173 3.955c.842-1.515 2.44-2.455 4.173-2.455s3.33.94 4.173 2.455l.302.545h-8.95l.302-.545Z"
  }));
};
SvgPersonAddIcon.displayName = "PersonAddIcon";

export { SvgPersonAddIcon as S };
